import React, { Component } from 'react'
import styles from './style.scss'
import MessageList from '../../containers/messages/List'
import MessageDetails from '../../containers/messages/Details'

class Messages extends Component {
  render() {

    console.log(this.props.match.params.uuid)

    return (
      <React.Fragment>

        <div className="messages-container">
          <div className="messages-list">
            <MessageList
              active={this.props.match.params.uuid}
            /> 
          </div>

          <div className="details-section">
              {this.props.match.params.uuid && <MessageDetails uuid={this.props.match.params.uuid} /> }
          </div>

        </div>

        
    </React.Fragment>
      
    );
  }
}

export default Messages;



// WEBPACK FOOTER //
// ./src/views/Messages/index.js